<template>
    <div class="create-notification">
        <div class="notifications">
            <div class="table">
                <center>
                    <h3>Lista de Notificaciones</h3>
                    <div v-for="(item, index) in notificationsList" :key="index" @click="selectedNotification(index)" :class="{'select': item.select}">
                        <label class="border-label" style="width: 100px">{{item.created_at.split($store.state.constants.SEPARETOR)[0]}}</label>
                        <label class="border-label" style="width: 400px">{{item.titulo}}</label>
                        <label class="border-label">{{item.system_status}}</label>
                        <label>{{item.tipo}}</label>
                    </div>
                </center>
            </div>
            <div class="details">
                <center><h3>{{selectTitulo}}</h3></center>
                <div>
                    <div>
                        <label for="">Fecha: <span>{{selectCreated}}</span></label>
                        <label for="">Grupo: <span>{{selectGroup}}</span></label>
                        <label for="">Tipo: <span>{{selectType}}</span></label>
                    </div>
                    <div>
                        <label for="">Creador: <span>{{selectWho}}</span></label>
                        <label for="">F. envio: <span>{{selectDate}}</span></label>
                        <label for="">Estado: <span>{{selectStatus}}</span></label>
                        <label for="">Cantidad: <span>{{selectCant}}</span></label>
                    </div>
                    <div>
                        <label for="">Detalles</label>
                        <p>{{selectDetails}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="models">
            <div class="list">
                <center><h3>Lista de modelos</h3></center>
                <div v-for="(item, index) in modelsList" :key="index">
                    <img :src="item.photo" alt="">
                    <div>
                        <label for="">{{ item.model }}</label>
                        <span>{{ item.turno }}</span>
                        <span>{{ item.tipo }}</span>
                    </div>
                    <label ><span :class="{'vista': item.status === 'vista', 'entregada': item.status === 'entregada'}">{{item.status}}</span></label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import API from '@/api'

export default {
    data() {
        return {
            modelsList: [],
            notificationsList: [],
            limit: 30,
            offset: 0,
            selectTitulo: null,
            selectCreated: null,
            selectGroup: null,
            selectType: null,
            selectWho: null,
            selectDate: null,
            selectStatus: null,
            selectCant: null,
            selectDetails: null,
            back_index: -1
        }
    },
    props: {
        notification_id: Number
    },
    methods: {
        selectedNotification(index) {
            if (this.back_index >= 0) {
                this.notificationsList[this.back_index].select = false
            }
            this.notificationsList[index].select = true
            this.selectTitulo = this.notificationsList[index].titulo
            this.selectCreated = this.notificationsList[index].created_at !== null ? this.notificationsList[index].created_at.split(this.$store.state.constants.SEPARETOR)[0] : ''
            this.selectGroup = this.notificationsList[index].group
            this.selectType = this.notificationsList[index].type
            this.selectWho = this.notificationsList[index].who
            this.selectDate = this.notificationsList[index].time_send !== null ? this.notificationsList[index].time_send.split(this.$store.state.constants.SEPARETOR)[0] : ''
            this.selectStatus = this.notificationsList[index].system_status
            this.selectCant = this.notificationsList[index].cantidad
            this.selectDetails = this.notificationsList[index].detalles
            this.modelsList = this.notificationsList[index].modelos
            this.back_index = index
        },
        getNotifications() {
            API.getNotifications(this.limit, this.offset, 'entregada')
                .then((res) => {
                    this.notificationsList = res
                    var index
                    if (!this.notification_id) {
                        this.notification_id = this.notificationsList[0].id
                        index = 0
                    } else {
                        index = this.notificationsList.findIndex(object => { return object.id === this.notification_id })
                    }
                    this.selectedNotification(index)
                })
        }
    },
    mounted() {
        this.getNotifications()
    }
}
</script>

<style scoped>
    .create-notification {
        background-color: #cdcdcd;
        height: 90vh;
        padding: 20px;
        color: #000;
        display: flex;
    }
    .create-notification > .notifications {
        width: 60%;
        height: 100%;
    }
    .create-notification > .notifications > .table{
        width: 100%;
        height: 60%;
        padding: 20px;
        border-radius: 20px;
        border-style: outset;
        background-color: #63b1b7;
    }
    .create-notification > .notifications > .table > center {
        width: 100%;
    }
    .create-notification > .notifications > .table > center > h3 {
        color: #fff;
    }
    .create-notification > .notifications > .table > center > div {
        background: #2b2926;
        margin: 20px;
        color: #fff;
        border-radius: 20px;
        height: 30px;
        position: relative;
        width: 90%;
    }
    .create-notification > .notifications > .table > center > .select {
        background-color: #22bb33;
    }
    .create-notification > .notifications > .table > center > div > label {
        width: 20%;
    }
    .create-notification > .notifications > .details{
        width: 100%;
        height: 38%;
        padding: 20px;
        border-radius: 20px;
        border-style: outset;
        background-color: #8363b7;
    }
    .create-notification > .notifications > .details > div {
        display: flex;
        width: 100%;
    }
    .create-notification > .notifications > .details > div > div{
        width: 33%;
        display: grid;
    }
    .create-notification > .notifications > .details > div > div > label{
        font-size: 20px;
        color: #fff;
        font-weight: bold;
    }
    .create-notification > .notifications > .details > div > div > p{
        font-size: 20px;
        color: #000;
        float: right;
        padding-right: 30px;
        background-color: #fff;
        text-align: center;
        border-radius: 20px;
    }
    .create-notification > .notifications > .details > div > div > label > span{
        font-size: 18px;
        color: #000;
        float: right;
        padding-right: 30px;
        text-transform: capitalize;
    }
    .create-notification > .notifications > .details > center > h3 {
        color: #fff;
        background-color: #2b2926;
    }
    .create-notification > .models {
        width: 40%;
        height: 100%;
        padding-left: 20px;
    }
    .create-notification > .models > .list > center > h3 {
        color: #fff;
    }
    .create-notification > .models > .list{
        width: 100%;
        height: 100%;
        border-radius: 20px;
        border-style: outset;
        padding: 20px;
        background-color: #585858;
        overflow-y: auto;
    }
    .create-notification > .models > .list > div{
        background: #2b2926;
        margin: 20px;
        color: #fff;
        border-radius: 20px;
        height: 100px;
        position: relative;
        display: flex;
        padding: 10px 40px;
    }
    .create-notification > .models > .list > div > img{
        width: 80px;
        height: 80px;
        object-fit: cover;
        margin-right: 60px;
        border-radius: 50%;
    }
    .create-notification > .models > .list  > div > div {
        display: grid;
        text-align: left;
    }
    .create-notification > .models > .list > div > label{
        width: 49%;
        text-align: center;
        padding: 3px;
        position: absolute;
        right: 20px;
        bottom: 20px;
    }
    .create-notification > .models > .list > div > label >.vista{
        background-color: #22bb33;
        border-radius: 20px;
        padding-left: 10px;
        padding-right: 10px;
    }
    .create-notification > .models > .list > div > label > .entregada {
        background-color: #63b1b7;
        border-radius: 20px;
        padding-left: 10px;
        padding-right: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Notificaciones/NotificationSent.vue